import React from 'react';

import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';

import FieldHistoryTable from './FieldHistoryTable';
import type { FieldHistoryEntry } from './types';

const PREVIEW_ROW_COUNT = 5;

interface Props {
  chipLabel?: string;
  entries: Array<FieldHistoryEntry>;
  // When set, only the latest rows are previewed and "View all" calls this to open the full report
  onViewAll?: () => void;
  title?: string;
}

export default function FieldHistoryPanel({ chipLabel, entries, onViewAll, title = 'History' }: Props) {
  const visibleEntries = onViewAll ? entries.slice(0, PREVIEW_ROW_COUNT) : entries;
  const viewAllLabel = entries.length > PREVIEW_ROW_COUNT ? `View all (${entries.length})` : 'View all';

  return (
    <Paper variant="outlined">
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 3, py: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Typography variant="h6">{title}</Typography>
          {chipLabel && <Chip color="primary" label={chipLabel} size="small" variant="outlined" />}
        </Stack>
        {onViewAll && entries.length > 0 && (
          <Button variant="text" onClick={onViewAll}>
            {viewAllLabel}
          </Button>
        )}
      </Stack>
      <Box sx={{ borderTop: 1, borderColor: 'divider' }}>
        <FieldHistoryTable entries={visibleEntries} />
      </Box>
    </Paper>
  );
}
